module.exports = __webpack_public_path__ + "img/mascot-more-info.4ca17717.svg";